import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function CustomerGate({ children }) {
  const loc = useLocation();

  const selected =
    (typeof localStorage !== 'undefined' && localStorage.getItem('selectedCustomerId')) ||
    (typeof localStorage !== 'undefined' && localStorage.getItem('customerId')) ||
    null;

  if (!selected) {
    return <Navigate to="/select-customer" replace state={{ from: loc.pathname }} />;
  }

  return children;
}
